//export const API_URL = "https://vinhomes-backend.onrender.com";
export const API_URL = "http://localhost:5000";